import React, { FC } from 'react';

import { IonReorderGroup } from '@ionic/react';
import { IonReorderGroupProps } from '../../common/components.types';

export const AllieReorderGroup: FC<IonReorderGroupProps> = (props) => {
  return <IonReorderGroup {...props} />;
};
